/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Create_ButtonInputs */

const en_admin_invite_codes_create_button = /** @type {(inputs: Admin_Invite_Codes_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Invite Code`)
};

/**
* | output |
* | --- |
* | "New Invite Code" |
*
* @param {Admin_Invite_Codes_Create_ButtonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_create_button = /** @type {((inputs?: Admin_Invite_Codes_Create_ButtonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Create_ButtonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_create_button(inputs)
});
export { admin_invite_codes_create_button as "admin.invite_codes.create_button" }